import CreateChartLightbox from './CreateChartLightbox'
import Ext from 'Ext'
import messageResource from '../../messageResource'
import rpcCall from '../../util/rpc/rpcCalls'
import LoadingPopup from '../../LoadingPopup'
import CreateChartButton from '../at_create_chart_button'

export default class ChartMediator {
    constructor(createButton = true, needToReloadPageAfterClose = true) {
        if (createButton) {
            const createChartButtonElementId = new CreateChartButton({
                renderTo: 'createChartButton',
                buttonText: messageResource.getMessage('report.create_chart_button.title'),
                hideOnResize: true
            }).id

            Ext.apply(Ext.getCmp(createChartButtonElementId), {clickAction: () => this.loadNewChartData()})
        }
        this.needToReloadPageAfterClose = needToReloadPageAfterClose
    }

    showCreateChartLightbox(popupData, chartType, chartDataParameters, chartDisplayParameters,
        chartPoints, makeChartPointsException, chartId, chartName) {
        new CreateChartLightbox().init({
            popupId: "createChartLightbox",
            closeBtnId: "closeCreateChartLightboxButton",
            chartContainerId: "chartContainer",
            partsContainerId: "chartPart",
            totalValueContainer: ".grandTotalValue",
            chartPopupData: popupData,
            chartType: chartType,
            chartDataParameters: chartDataParameters,
            chartDisplayParameters: chartDisplayParameters,
            chartPoints: chartPoints,
            makeChartPointsException: makeChartPointsException,
            chartId: chartId,
            chartName: chartName,
            needToReloadPageAfterClose: this.needToReloadPageAfterClose
        }).show()
    }

    loadNewChartData() {
        this.showLoadingPopup()
        rpcCall("ReportChartService.getNewChartData", [],
            () => {
                this.hideLoadingPopup()
                return false
            }
        ).then(result => {
                this.hideLoadingPopup()
                this.showCreateChartLightbox(
                    result.popupData,
                    result.chartType,
                    result.chartDataParameters,
                    result.chartDisplayParameters,
                    result.chartPoints,
                    result.makeChartPointsException,
                    null,
                    null,
                    result.showStackColumnsCheckMark
                )
            }
        )
    }

    showChart(configId) {
        this.showLoadingPopup()
        rpcCall("ReportChartService.getChartData", [configId],
            (rpcError) => {
                if (rpcError.getTextStatus() === "rpc_customException") {
                    this.hideLoadingPopup()
                    if (rpcError.getErrorThrown().exception === "com.actimind.actitime.reports.NoSuchReportConfigException" ||
                        rpcError.getErrorThrown().exception === "com.actimind.actitime.reports.charts.ReportConfigOfAnotherUserException") {
                        alert(messageResource.getMessage("saved_reports.load.no_such_chart_config"))
                        document.location.reload()
                        return true
                    }
                }
                return false
            }
        ).then(result => {
            this.hideLoadingPopup()
            this.showCreateChartLightbox(
                result.popupData,
                result.reportConfig.type,
                result.reportConfig.configParams.dataParameters,
                result.reportConfig.configParams.displayParameters,
                result.chartPoints,
                result.makeChartPointsException,
                result.reportConfig.id,
                result.reportConfig.name)
        })
    }

    showLoadingPopup() {
        this.loadingPopup = new LoadingPopup().init("reportChartLoadingPopup")
        this.loadingPopup.show()
    }

    hideLoadingPopup() {
        this.loadingPopup.hide()
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartMediator.js